function PageNotFound() {
  return (
    <div className="content-xl grid grid-cols-2 gap-2 py-20">
      <div className="col-span-2 lg:order-last lg:col-span-1">
        <img src="/Images/MeowSeo_03.png" className="w-full" />
      </div>
      <div className="col-span-2 flex flex-col items-center justify-center lg:col-span-1 lg:items-start lg:pl-32">
        <div>
          <h3 className="mb-4 text-7xl font-bold text-teal-700 xs:text-9xl">Oops!</h3>
          <div className="text-2xl font-bold text-gray-700 xs:text-4xl">
            We can't seems to find the
          </div>
          <div className="text-2xl font-bold text-gray-700 xs:text-4xl">
            page you're looking for
          </div>
          <div className="mt-8 text-xl text-gray-500 xs:text-2xl">Error code: 404</div>
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
